export const TENERA_FOLDER_NAME = "Tenera Solutions";
